<template>
  <div class="about_us container">

    <section>
      <article>
        <b-row>
          <b-col sm="4" class="center-items-top">
            <div class="main_title">
              <h1 class="text-center">
                <strong>ما هو</strong>
                اجازة بوك
              </h1>
              <UnderLine/>
            </div>
          </b-col>
          <b-col>
        <p>موقع أجـــازة بــوك هو بوابتك المميزة للسفر في أي مكان داخل أو خارج جمهورية مصر العربية لو حابب تسافر وتتعرف علي كل أماكن العالم السياحية ، وتستمتع بكل شبر داخل وخارج مصر وتعيش المغامرة مع اصحابك وتتفسح مع عيلتك، تقدر تتصفح أجـــازة بــوك وتختار عايز تسافر فين وأمتي وبكـــام. أما بالنسبة لمستخدمي الموقع من شركات السياحة – شركاؤنا الكرام – يمكنكم عمل عروض تسويقية لكلاً من البرامج والفنادق وكمان متاح خاصية انك تعرض برامج او فنادق للبيع والشراء. بإختصار مع أجــازة بــوك تقدر تختار وتحجز سفريتك تسوق برامج السياحة الدخلية والخارجية والدينية وغيره لشركتك وتاخد white label تبيع وتشتري حجوزات فنادق أجـــــــــازة بـــوك هو احد منتجات شركة ماستر فيجن للحلول المتكاملة لسنا فقط مقدمي خدمة بل شركائك الي النجاح</p>
          </b-col>
        </b-row>
        <div class="clearfix"></div>

      </article>
    </section>
  </div>
</template>
<script>
import UnderLine from "../global/UnderLine"
  export default {
    components: {
      UnderLine
    }
  }
</script>
